//MV
document.addEventListener("DOMContentLoaded", () => {
  const init = (root) => {
    if (!root) return;
    if (root.classList.contains("swiper-initialized")) return;

    const pag = root.querySelector(".swiper-pagination");
    const autoplay = root.getAttribute("data-autoplay") === "true";
    const delay = Number(root.getAttribute("data-delay") || 4000);

    new Swiper(root, {
      loop: true,
      speed: 800,
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: pag ? { el: pag, clickable: true } : false,
      autoplay: autoplay ? { delay, disableOnInteraction: false } : false,
    });
  };

  document.querySelectorAll("[data-mv-swiper]").forEach(init);

  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelectorAll?.("[data-mv-swiper]")?.forEach(init);
  });
});

/* ==========================================================================
   top-products : collection slider
   ========================================================================== */
(function () {
  function initTopProductsSlider(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll(".top-products__slider");
    if (!sliders.length || typeof Swiper === "undefined") return;

    sliders.forEach(function (el) {
      if (el.dataset.swiperInitialized === "1") return;

      var section = el.closest(".top-products");
      var prevEl = section
        ? section.querySelector(".top-products__nav-button--prev")
        : null;
      var nextEl = section
        ? section.querySelector(".top-products__nav-button--next")
        : null;

      new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 2,
        speed: 600,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        breakpoints: {
          750: {
            spaceBetween: 4,
            slidesOffsetBefore: 40,
            slidesOffsetAfter: 40,
          },
          990: {
            spaceBetween: 4,
            slidesOffsetBefore: 120,
            slidesOffsetAfter: 120,
          },
        },
      });

      el.dataset.swiperInitialized = "1";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initTopProductsSlider(document);
  });

  // Shopify テーマエディタでセクションが再描画された際の再初期化
  document.addEventListener("shopify:section:load", function (e) {
    initTopProductsSlider(e.target);
  });
})();

//Our story
(function () {
  'use strict';

  function initMarquee(marquee) {
    var track = marquee.querySelector('.our-story-marquee__track');
    if (!track) return;

    var originalList = track.querySelector('.our-story-marquee__list');
    if (!originalList) return;

    // Duplicate the list once so the CSS animation can loop seamlessly
    // (animation translates the track from -50% to 0%).
    if (track.children.length < 2) {
      var clone = originalList.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // Pause animation when the marquee is off-screen to save CPU.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            track.style.animationPlayState = entry.isIntersecting
              ? 'running'
              : 'paused';
          });
        },
        { threshold: 0 }
      );
      observer.observe(marquee);
    }
  }

  function init() {
    var marquees = document.querySelectorAll('[data-our-story-marquee]');
    marquees.forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
